import { FrontendErrorEventRequestModel, FrontendLoggerLevel } from '@ps20/bff-models';

export const ERROR_DESCRIPTION_MAX_LENGTH = 500000;
export const SOURCE_APP_NAME_MAX_LENGTH = 20;

export const createPayload = (
  loggerLevel: FrontendLoggerLevel,
  sourceApp?: string,
  exceptionText?: string,
  description?: string,
): FrontendErrorEventRequestModel => ({
  loggerLevel,
  sourceApp: (sourceApp || '').slice(0, SOURCE_APP_NAME_MAX_LENGTH),
  description: (description || '').slice(0, ERROR_DESCRIPTION_MAX_LENGTH),
  exceptionText: (exceptionText || '').slice(0, ERROR_DESCRIPTION_MAX_LENGTH),
});
